module.exports = __webpack_public_path__ + "static/img/cancer_icon-38.bde17ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cancerrealtime/cancer_icon-38.png
// module id = Ty4k
// module chunks = 0